import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MasterConsultaProfileService } from './master-bo-consulta-perfil.service';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { MasterVisualizarClienteComponent } from '../visualizar-cliente/master-visualizar-cliente.component';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { PermissionsType } from '@app/custom-shared/enums/permissions-type.enum';

/**
 * This Component manages the presentation logic of Edit screen
 *
 */
@Component({
  selector: 'app-master-bo-consulta-perfil',
  templateUrl: './master-bo-consulta-perfil.component.html',
  styleUrls: ['./master-bo-consulta-perfil.component.scss'],
})
export class MasterBOConsultaProfileComponent implements OnInit {
  profiles: any;
  autoComplete: any;
  profilesFilter: any;
  dialogConfig: any;
  userFilter = '';
  clientStatus = false;
  criar: boolean = false;

  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _masterProfileService: MasterConsultaProfileService,
    private dialog: MatDialog,
    private customAuthenticationService: CustomAuthenticationService,
  ) {

  }

  ngOnInit() {
    this.getProfiles();
    this.dialogConfig = new MatDialogConfig();

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';

    this.criar = this.customAuthenticationService.hasPermission(
      PermissionsType.criarPerfilDeAcesso,
    );
  }

  sortProfiles(result) {
    this.profiles = result.map((pro, i) => {
      if (pro.permissionGroupProfiles == undefined) {
        pro.permissionGroupProfiles = [
          {
            id: '0',
            profile: ' ',
            description: '',
            members: 0,
          },
        ];
      }
      pro.permissionGroupProfiles.sort((a, b) => {
        return a.profile.toLowerCase() > b.profile.toLowerCase() ? 1 : -1;
      });
      return pro;
    });
    this.proxyAutoComplete();
  }

  async getProfiles(status = false) {
    await this._masterProfileService.getProfiles(status)
      .then(response => {
        this.profiles = response.naturalSort(['name']);
        this.profilesFilter = response.naturalSort(['name']);
      });
  }

  toggleStatus() {
    this.clientStatus = !this.clientStatus;
    this.getProfiles(this.clientStatus);
  }

  // async filterUsers(event: Event) {
  //   this.userFilter = (event.target as HTMLInputElement).value;

  //   if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {

  //     this.sortProfiles(result);
  //     this.proxyAutoComplete(this.userFilter);
  //   } else if (this.userFilter.length == 0) {
  //     this.getProfiles(this.clientStatus);
  //     this.filterAutoComplete = [];
  //   }
  // }



  filterUsers(event: Event) {
    this.userFilter = (event.target as HTMLInputElement).value.naturalNormalize();
    if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {
      this._masterProfileService.getProfileSearch(this.userFilter).then(response => {
        this.profilesFilter = response;
      });
      this.profilesFilter.naturalSort('name');
      this.proxyAutoComplete(this.userFilter);

    } else if (this.userFilter.length == 0) {
      this.profilesFilter = [];
      this.autoComplete = [];
    }
  }

  proxyAutoComplete(term = null) {
    if (!term) return;
    const complete = this.profiles.map(client => {
      return client.permissionGroupProfiles
        .filter(prof => {
          return prof.profile != undefined;
        })
        .map(pro => {
          return pro.profile;
        });
    });
    this.autoComplete = new Set(
      [].concat(...complete)
        .filter(ele => ele.toLowerCase().includes(term.toLowerCase())),
    );
  }

  openDialogVisualizarClient(id) {
    const dialogRef = this.dialog.open(
      MasterVisualizarClienteComponent,
      this.dialogConfig,
    );
    dialogRef.componentInstance.id = id;
  }
}
